import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';
import { UserDataProgress } from '../../common/userDataProgress/userDataProgress';

export default class PendingIcon extends Component {
  render() {
    const { emoji, notShowText } = this.props;
    return (
      <div className="pending-icon">
        <div className="circle">
          {/* <span className='custom-icons-edit-document'/>*/}
          <img src={emoji} alt={emoji} />
        </div>
        <div className="pending-icon-text-container">
          {!notShowText ? <span className="pending-icon-text">{I18n.t('tasks.gradeIcon.pending')}</span> : null}
        </div>
      </div>
    );
  }
}
PendingIcon.propTypes = {
  emoji: PropTypes.string
};
